// extracted by mini-css-extract-plugin
export default {"card":"GalleryCard_card__lo2TC","mainImage":"GalleryCard_mainImage__RxNwE","otherImages":"GalleryCard_otherImages__Muq1k","title":"GalleryCard_title__XTN+X"};